import React, { useEffect, useMemo } from "react";
import {
  defaultTimeoutSeconds,
  defaultTimeoutMilliseconds,
} from "../../model/Configuration";
import { RetorikNews } from "@davi-ai/retorik-framework";
import type {
  Configuration,
  ChatbotData,
  PonyfillFactoryCredentials,
  AddressData,
  UserData,
} from "@davi-ai/retorik-framework";
import {
  useConfiguration,
  useAgent,
  useVoice,
  useChatbot,
  useViewsConfiguration,
} from "../../redux/Hooks";

const allowedPrefixes = ["dev", "staging", "preview", "experimental"];

const InfoChannel = (props: { switchComponent: Function; loop: boolean }) => {
  const configuration: Configuration = useConfiguration();
  const chatbotData: ChatbotData | undefined = useChatbot();
  const agent = useAgent();
  const voice = useVoice();
  const viewsConfiguration = useViewsConfiguration();

  const agentData = useMemo(() => {
    return agent?.agentPackage || null;
  }, [agent]);

  const addressData: AddressData | null = useMemo(() => {
    if (agent && agent.tenant) {
      let prefix: string | undefined = undefined;
      if (agent.baseUri) {
        const temp = agent.baseUri.split(".")[0];
        allowedPrefixes.includes(temp) && (prefix = temp);
      }

      return {
        tenant: agent.tenant,
        prefix: prefix,
      };
    }

    return null;
  }, [agent]);

  const ponyfillFactoryCredentials: PonyfillFactoryCredentials | null =
    useMemo(() => {
      if (agent) {
        return agent?.speechServicesToken && agent?.speechServicesRegion
          ? {
              region: agent.speechServicesRegion,
              subscriptionKey: agent.speechServicesToken,
            }
          : {
              region: "francecentral",
              subscriptionKey: "2f62867e22a544b78a16c99a2707ef49",
            };
      } else {
        return null;
      }
    }, [agent]);

  const userData: UserData = {
    name: "DAVI",
    id: "",
    username: "DAVI",
    nom: "RETORIK",
    prenom: "Davi",
    email: "davi@davi.ai",
    token: "",
    referrer: "",
    ipaddress: "",
  };

  useEffect(() => {
    var timer: any = null;
    document.addEventListener("newsEnded", () => {
      // Switch to next component only if loop isn't true
      timer = props.loop
        ? null
        : setTimeout(
            () => {
              props.switchComponent();
            },
            typeof viewsConfiguration.views.news?.intervalInSeconds === "number"
              ? viewsConfiguration.views.news.intervalInSeconds * 1000
              : defaultTimeoutMilliseconds
          );
    });

    return () => timer && clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      {viewsConfiguration &&
      ponyfillFactoryCredentials &&
      addressData &&
      agentData ? (
        <RetorikNews
          config={{ ...configuration, enableConversationCookie: true }}
          viewsConfig={{
            ...viewsConfiguration,
            views: {
              ...viewsConfiguration.views,
              news: {
                ...viewsConfiguration.views.news,
                loop: props.loop,
                intervalInSeconds: viewsConfiguration.views.news
                  .intervalInSeconds
                  ? viewsConfiguration.views.news.intervalInSeconds
                  : defaultTimeoutSeconds,
              },
            },
          }}
          // agentData={agentData}
          chatbotData={chatbotData}
          ponyfillFactoryCredentials={ponyfillFactoryCredentials}
          addressData={addressData}
          userData={userData}
          customVoice={voice}
          skipLoader={true}
        />
      ) : null}
    </React.Fragment>
  );
};

export default InfoChannel;
